module.exports = __webpack_public_path__ + "static/media/icons8-shopping-bag-gray.152513bc.svg";